import gql from 'graphql-tag';

const HOMECARD_CONTENT = `
      checked
      currencyIsoCode
      firstAvailableDate
      id
      city
      isInstantBooking
      noSecurityDeposit
      hasDepositProtection
      isFavorite
      mainPhotoUrl
      reviews {
        ratingAverage
      }
      title
      description
      type
      url
      features
      area
      roomArea
      offers {
        discountType
        discountValue
      }
      allowsPermanentContract
      numberOfBathrooms
      numberOfBedrooms
      isBestChoice
      location
      landlordId
      so
      photoIds
      otherPropertyPhotoIds
      displayPrice
      billsIncluded
      totalCountMultilisting
      landlordScoring {
        score
        totalBookingsClosed
      }
`;

const QUERY_HOMECARDS = gql`
  query Homecards($ids: [Int], $locale: String = "en") {
    homecards(homecardIds: $ids, locale: $locale) {
      ${HOMECARD_CONTENT}
    }
  }
`;

const QUERY_HOMECARD_MAP = gql`
  query HomecardMap($ids: [Int], $locale: String = "en") {
    homecards(homecardIds: $ids, locale: $locale) {
      ${HOMECARD_CONTENT}
    }
  }`;

const QUERY_HOMECARD_MAP_DESKTOP = gql`
  query HomecardMapDesktop($ids: [Int], $locale: String = "en") {
    homecards(homecardIds: $ids, locale: $locale) {
      ${HOMECARD_CONTENT}
    }
  }`;

export const getHomecardMapQuery = client => (ids, locale) =>
  client.query({
    fetchPolicy: 'cache-first',
    query: QUERY_HOMECARD_MAP,
    variables: { ids, locale }
  });

export const getHomecardMapDesktopQuery = client => (ids, locale) =>
  client.query({
    fetchPolicy: 'cache-first',
    query: QUERY_HOMECARD_MAP_DESKTOP,
    variables: { ids, locale }
  });

export const getHomecardsQuery =
  client =>
  (ids, locale, context = {}) =>
    client.query({
      fetchPolicy: 'cache-first',
      query: QUERY_HOMECARDS,
      context,
      variables: { ids, locale }
    });

export default getHomecardsQuery;
